module.exports = __webpack_public_path__ + "static/media/bo.fb4584a1.svg";